import {useIsMobile} from "./context/mobileContext";
import VolleyballMobileDashboard from "./screens/volleyballMobileDashboard";
import VolleyballDesktopDashboard from "./screens/volleyballDesktopDashboard";

const VolleyballDashboard = () => {
  const isMobile = useIsMobile();
  return isMobile ? <VolleyballMobileDashboard /> : <VolleyballDesktopDashboard />
}

export default VolleyballDashboard
